<template>
  <listCategoriesComponent/>
</template>

<script>
import listCategoriesComponent from "@/views/categories_board/pages/list_categories/components/list_categories_component.vue";
export default {
  name: "categories",
  components: {
    listCategoriesComponent,
  },
};
</script>

<style lang="css" scoped>
</style>
